import styled from 'styled-components';
import { breakpoints } from '../../../constants';

export const Text = styled.p`
    line-height: 1.8;

    @media (${breakpoints.mediumMin}) {
        font-size: 18px;
    }
`;
